export function patientHidesShopTab(patient = {}) {
  const resolvedPatient = patient && typeof patient === 'object' ? patient : {}
  return Boolean(
    resolvedPatient.hideShopTab ||
    resolvedPatient.hide_shop_tab ||
    resolvedPatient.portalAccess?.hideShopTab ||
    resolvedPatient.portalAccess?.hide_shop_tab ||
    resolvedPatient.portal_access?.hideShopTab ||
    resolvedPatient.portal_access?.hide_shop_tab
  )
}

export function isShopRoutePath(pathname = '') {
  return ['/shop', '/intake', '/refill'].some(path =>
    pathname === path || pathname.startsWith(`${path}/`)
  )
}
